
import { IDS } from "./pnp-doc.constants";


export const addDocumentAddState = {
    name: IDS.app_policies_documents_add,
    redirectTo: IDS.app_policies_documents_add_details,
    url: '/add',
    component: 'tabs'
};

export const pnpDocumentAddDetailsState = {
    name: IDS.app_policies_documents_add_details,
    url: '',
    component: 'pnpDocument',
    /* @ngInject */
    onEnter: ($ngRedux) => {
        $ngRedux.dispatch({
            type: 'PNP_DOCUMENT_RESET',
            id: 'pnpDocument'
        });
    }
};

export const pnpDocumentManageState = {
    name: IDS.app_policies_documents_manage,
    redirectTo: IDS.app_policies_documents_manage_listing,
    url: '/manage',
    component: 'tabs',
};

export const pnpDocumentManageListingState = {
    name: IDS.app_policies_documents_manage_listing,
    url: '',
    component: 'pnpDocumentGrid',
    /* @ngInject */
    onEnter: ($ngRedux) => {
        $ngRedux.dispatch({
            type: 'TAB_HIDE',
            id: IDS.app_policies_documents_manage,
            state: [
                IDS.app_policies_documents_manage_details,
                IDS.app_policies_documents_accreditation_add_details,
                IDS.app_policies_documents_accreditation_manage_listing,
                IDS.app_policies_documents_manage_history_details,
                IDS.app_policies_documents_manage_history_listing,
                IDS.app_policies_documents_event_actions_manage_listing
            ]
        });
    }
};

export const pnpDocumentManageDetailsState = {
    name: IDS.app_policies_documents_manage_details,
    url: '/details?id',
    component: 'pnpDocument'
};

export const pnpDocumentManageHistoryListingState = {
    name: IDS.app_policies_documents_manage_history_listing,
    url: '/history',
    component: 'pnpDocumentHistoryGrid',
    /* @ngInject */
    onEnter: ($ngRedux) => {
        $ngRedux.dispatch({
            type: 'TAB_HIDE',
            id: IDS.app_policies_documents_manage,
            state: [IDS.app_policies_documents_manage_history_details]
        });
    }
};

export const pnpDocumentManageHistoryDetailsState = {
    name: IDS.app_policies_documents_manage_history_details,
    url: '/history/details?id',
    component: 'pnpDocHistoryDetails'
};

export const pnpDocumentAccreditationListingState = {
    name: IDS.app_policies_documents_accreditation_manage_listing,
    url: 'details?id',
    component: 'pnpDocumentAccreditationGrid',
      /* @ngInject */
      onEnter: ($ngRedux) => {
        $ngRedux.dispatch({
            type: 'TAB_HIDE',
            id: IDS.app_policies_documents_manage,
            state: [IDS.app_policies_documents_accreditation_add_details]
        });
    }
};

export const pnpDocumentEventActionsListingState = {
    name: IDS.app_policies_documents_event_actions_manage_listing,
    url: 'details?id',
    component: 'pnpDocumentEventActionsGrid',
};


